module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"messagebtn":"こんにちは、世界！"},"en":{"messagebtn":"hello world!"}}')
  delete Component.options._Ctor
}
